<h2 mat-dialog-title>Problema na sua assinatura</h2>
<mat-dialog-content>
    <p>{{ signatureStatusText }}</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">Fechar</button>
</mat-dialog-actions>